"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMerchRecommendations = exports.useFetchPrompts = void 0;
var _react = require("react");
var _utils = require("@site/utils");
var _domainServices = require("@site/domain-services");
var _DomainServices = require("../services/DomainServices");
var _constants = require("../constants");
var _EidCodes = _interopRequireDefault(require("../EidCodes"));
const useFetchPrompts = (params = {}, options = {}) => {
  const {
    urlOverride,
    apm,
    eidPrefix,
    ...rest
  } = params;
  const plid = params.plid;
  const isPromptFetchEligible = options?.selection && !(0, _utils.isReseller)(plid);
  const [promptsData, setPromptsData] = (0, _react.useState)(null);
  const [promptStatus, setPromptStatus] = (0, _react.useState)(_constants.REQUEST_STATUS.INIT);
  const [promptResponseError, setPromptResponseError] = (0, _react.useState)(null);
  const eid = eidPrefix + _EidCodes.default.promptRecommendation;
  const fetchData = async () => {
    setPromptStatus(_constants.REQUEST_STATUS.LOADING);
    try {
      const response = await (0, _DomainServices.callPromptRecommendationApis)(rest, urlOverride, apm);
      const {
        merchData,
        ventureData
      } = response || {};
      if (merchData?.recommendations?.length > 0 || ventureData?.ventures?.length > 0) {
        (0, _utils.logImpression)(eid);
        setPromptsData(response);
        setPromptStatus(_constants.REQUEST_STATUS.SUCCESS);
        return;
      }
      setPromptStatus(_constants.REQUEST_STATUS.UNAVAILABLE);
    } catch (err) {
      setPromptResponseError(err);
      setPromptStatus(_constants.REQUEST_STATUS.FAIL);
    }
  };
  (0, _react.useEffect)(() => {
    if (isPromptFetchEligible) {
      fetchData();
    }
  }, [isPromptFetchEligible]);
  return [promptsData, promptStatus, promptResponseError];
};
exports.useFetchPrompts = useFetchPrompts;
const useMerchRecommendations = (args = {}) => {
  const {
    apm,
    disabled,
    ...params
  } = args;
  const {
    ventureId,
    domain,
    vertical
  } = params || {};
  const [status, setStatus] = (0, _react.useState)(_constants.REQUEST_STATUS.INIT);
  const [merchData, setMerchData] = (0, _react.useState)(null);
  const [merchError, setMerchError] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    setStatus(_constants.REQUEST_STATUS.LOADING);
    // Ignore fetching recommendations if disabled
    if (disabled && merchData === null) {
      // eslint-disable-line eqeqeq
      setStatus(_constants.REQUEST_STATUS.SUCCESS);
      return;
    }
    (0, _domainServices.getMerchRecommendPromise)(params, apm).then(result => {
      setMerchData((0, _DomainServices.normalizeMerchRecommendations)(result));
      setStatus(_constants.REQUEST_STATUS.SUCCESS);
    }).catch(error => {
      setStatus(_constants.REQUEST_STATUS.FAIL);
      setMerchError(error);
      console.error('useMerchRecommendations:error', error); // eslint-disable-line no-console
    });
  }, [ventureId, domain, vertical, disabled]);
  return [merchData, status, merchError];
};
exports.useMerchRecommendations = useMerchRecommendations;